import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { AuthService } from '@pw-utils/services/auth/auth.service';

@Injectable({ providedIn: 'root' })
export class UnAuthGuard  {
  constructor(private router: Router, private authService: AuthService) {}

  public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
    // pass if user is unauthenticated or return UrlTree for redirectPath
    return !this.authService.isAuthenticated() || this.router.parseUrl(route.data?.redirectPath);
  }
}
